import StrippedDataGrid from "components/styled";
import { reportTypes } from "./Types";
import { Paper } from "@mui/material";
import { gridClasses, useGridApiContext, useGridApiRef } from "@mui/x-data-grid";
import styles from "./ReportBody.module.css";
import { useEffect } from "react";

const ReportBody = ({type, data, setVisibledColumns, onReady}) => {

  const gridRef = useGridApiRef();

  useEffect(() => {
    if(gridRef.current) {
      onReady(gridRef);
    }
  }, []);

  const rowClassName = (row, indexRelativeToCurrentPage) => {
    let result = indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
    row.disabled && (result += ' disabled');
    return result;
  };

  return (
    <Paper className={styles.bgWrapper}>
      <StrippedDataGrid 
        apiRef={gridRef}
        density="compact"
        disableRowSelectionOnClick
        columns={reportTypes[type]}
        rows={data?.body.items ?? []} 
        getRowClassName={({row, indexRelativeToCurrentPage}) => rowClassName(row, indexRelativeToCurrentPage)}
        getRowId={(row) => row.virtualId} 
        getRowHeight={() => 'auto'}
        hideFooter 
        onColumnVisibilityModelChange={() => {
          const columns = gridRef.current.getVisibleColumns().map(col => col.field)
          setVisibledColumns(columns.reduce((acc, field) => ({...acc, [field]: true}), {}));
        }}
        sx={{
          maxWidth: '100%',
          fontSize: 12,
          width: '100%',
          [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
          },
          [`& .${gridClasses.columnHeader}, & .MuiInputBase-root`]: {
            overflowX: 'unset'
          },
          [`& .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus, & .${gridClasses.cell}.${gridClasses["cell--editing"]}:focus-within`]: {
            outline: 'none'
          },
          ['& .MuiDataGrid-root']: {
            width: '100%',
            minWidth: 0
          },
          '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
            py: 1,
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center'
          }
        }}
      />
    </Paper>
    
  );
};

export default ReportBody;